import styled from "styled-components";
import { AlertProps, DefaultAlertProps } from "./Alert.types.js";

const justifyMap: Record<DefaultAlertProps["textAlign"], "center" | "flex-end" | "flex-start"> = {
    center: "center",
    left: "flex-start",
    right: "flex-end",
};

export const StyledAlert = styled.div<AlertProps & DefaultAlertProps>`
    display: flex;
    align-items: center;
    justify-content: ${({ textAlign }) => justifyMap[textAlign]};
    width: ${({ flat }) => (flat ? "100%" : "fit-content")};
    padding: ${(props) => props.theme.spacing[12]};
    background-color: ${(props) => props.theme.colors[props.color][10]};
    border: 1px solid ${(props) => props.theme.colors[props.color][100]};
    border-radius: ${(props) => props.theme.radius.xs};
    color: ${(props) => props.theme.colors[props.color][100]};
    box-sizing: border-box;
`;
